import React, { PureComponent } from "react";
import PropTypes from "prop-types";
import classNames from "classnames";
import { withWidth, withStyles } from "@material-ui/core";
import numeral from 'numeral';
import { Link } from "react-router-dom";
import style from './styles.module.scss';
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import * as AuthActions from "./../../../../redux/actions/auth";
import { Form } from 'react-final-form';
import arrayMutators from 'final-form-arrays';
import { FieldArray } from 'react-final-form-arrays';
import sleep from './../../../../shared/functions/sleep';
import BackButton from './../../../../shared/components/BackButton';
import SecondaryNav from './../components/SecondaryNav';
import Button from '@material-ui/core/Button';
import Badge from '@material-ui/core/Badge';
import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableHead from '@material-ui/core/TableHead';
import TableRow from '@material-ui/core/TableRow';
import { TextField, Checkboxes } from 'mui-rff';
import CheckCircleIcon from '@material-ui/icons/CheckCircle';
import IconButton from '@material-ui/core/IconButton';
import AddIcon from '@material-ui/icons/Add';
import RemoveIcon from '@material-ui/icons/Remove';
import BoxButton from './../../../../shared/components/BoxButton';
import NoticeBar from './../../../../shared/components/NoticeBar';
import Popover from '@material-ui/core/Popover';
import makeStyles from "@material-ui/styles/makeStyles";
import api from 'shared/functions/api/'
import ToggleButton from "@material-ui/lab/ToggleButton";
import ToggleButtonGroup from "@material-ui/lab/ToggleButtonGroup";
import getSymbolFromCurrency from 'currency-symbol-map';
import { isOtherShape } from 'logged_out/components/diamonds/All';
import smoothScrollTop from "shared/functions/smoothScrollTop";
import { convertToCurrency } from 'shared/functions/priceCalc';

const useToggleButtonStyles = makeStyles((theme) => ({
    root: {
        borderRadius: 0,
        backgroundColor: 'white !important',
        marginTop: '0 !important',
    },
    selected: {
        border: '1px solid #B08F6E !important',
        marginRight: 1,
        color: '#B08F6E !important',
        fontWeight: 'bold'
    },
    label: {
        textTransform: "none",
    },
    sizeSmall: {
        paddingLeft: 20,
        paddingRight: 20,
        paddingTop: 5,
        paddingBottom: 5,
    }
}));

function ToggleButtons({ value, onChange, size = 'small' }) {
    const classes = useToggleButtonStyles();
    return (
        <ToggleButtonGroup value={value} exclusive onChange={onChange}>
            <ToggleButton value="weight" classes={classes} size={size}>
                Weight
      </ToggleButton>
            <ToggleButton value="items" classes={classes} size={size}>
                Items
      </ToggleButton>
        </ToggleButtonGroup>
    );
}


const styles = theme => ({
    noDecoration: {
        textDecoration: "none !important"
    },
    badge: {
        top: 23,
        left: 0,
        padding: '6px 6px',
        fontFamily: 'Lato',
        letterSpacing: 0.53,
        backgroundColor: '#b08f6e',
        position: 'relative'
    },
});

const NumberField = ({ name, classes, onChange, selectedUnit, size = 'small' }) => {
    const ref = React.useRef(null);
    const [itemType, setItemType] = React.useState(selectedUnit);

    const removeItem = () => {
        ref.current.stepDown();
        onChange(ref.current.value, itemType)
    }
    const addItem = () => {
        ref.current.stepUp();
        onChange(ref.current.value, itemType)
    }

    const handleToggleChange = (event, value) => {
        setItemType(value);
        if (value === 'weight') {
            onChange(0.01, value)
        } else {
            onChange(1, value)
        }
    };

    return (<React.Fragment>
        <div style={{ display: 'flex', marginBottom: 10, justifyContent: 'center' }}>
            <IconButton onClick={() => removeItem()} style={{ padding: 5 }}><RemoveIcon /></IconButton>
            <TextField
                type="number"
                name={name}
                required={true}
                classes={classes}
                InputProps={{ inputProps: { /* min: itemType === 'weight' ? 0.01 : 1,  */ step: itemType === 'weight' ? 0.01 : 1, ref, onChange: e => onChange(e.target.value, itemType) } }}
            />
            {itemType === 'weight' && <span>ct</span>}
            <IconButton onClick={() => addItem()} style={{ padding: 5 }}><AddIcon /></IconButton>
        </div>
        <div style={{ textAlign: 'center' }}>
            <ToggleButtons value={itemType} onChange={handleToggleChange} size={size} />
        </div>
    </React.Fragment>);
}

export const NumberFieldStyled = (props) => {
    const classes = useStyles();
    return <NumberField {...props} classes={{ root: classes.qtyField }} />;
}

const useStyles = makeStyles((theme) => ({
    popover: {
        pointerEvents: 'none',
    },
    paper: {
        padding: theme.spacing(1),
    },
    popoverContent: {
        maxWidth: 400,
        display: 'block'
    },
    qtyField: {
        width: 40,
        overflow: 'hidden',
        marginTop: -6,

        '& .MuiInput-root': {
            width: 75
        },
        '& input': {
            textAlign: 'center',
            paddingRight: 20
        }
    },
}));

function MouseOverPopover() {
    const classes = useStyles();
    const [anchorEl, setAnchorEl] = React.useState(null);

    const handlePopoverOpen = (event) => {
        setAnchorEl(event.currentTarget);
    };

    const handlePopoverClose = () => {
        setAnchorEl(null);
    };

    const open = Boolean(anchorEl);

    return (
        <div>
            <img alt=""
                aria-owns={open ? 'mouse-over-popover' : undefined}
                aria-haspopup="true"
                onMouseEnter={handlePopoverOpen}
                onMouseLeave={handlePopoverClose}
                src="/images/info.svg"
            />
            <Popover
                id="mouse-over-popover"
                className={classes.popover}
                classes={{
                    paper: classes.paper,
                }}
                open={open}
                anchorEl={anchorEl}
                anchorOrigin={{
                    vertical: 'bottom',
                    horizontal: 'left',
                }}
                transformOrigin={{
                    vertical: 'top',
                    horizontal: 'center',
                }}
                onClose={handlePopoverClose}
                disableRestoreFocus
            >
                <small className={classes.popoverContent}>
                    Ticking this option will allow our team to find you alternatives should one of the items no longer be available, awaiting return, or a better option has just been added to our stock.
                    <h4>Alternatives:</h4>
                    If an item is unavailable on the day of your Appro or Invoice request, our team can select a comparable alternative for you.
                    <h4>No extra cost:</h4>
                    Often even if we offer a more expensive alternative, you will not necessarily pay more than the price of the original item requested.
                    <p>*You can also choose your preference for each individual item.</p>
                </small>
            </Popover>
        </div>
    );
}

class Bag extends PureComponent {
    state = {
        sideDrawerOpen: false,
        tabsValue: 0,
        isSnackbarOpen: false,
        snackBarTitle: '',
        snackBarMsg: '',
        totalPrice: 0.00,
        orderNotes: '',
        acceptsAnyAlternatives: false,
    }

    componentDidMount() {
        const { selectBag = () => { } } = this.props;
        //const { diamondId, page } = this.props.match.params;

        selectBag();
    }

    openOrderBox = () => {
        this.setState({ sideDrawerOpen: 'bag' });
    };

    closeOrderBox = () => {
        this.setState({ sideDrawerOpen: false });
    };

    openSnackbar(severity /* error | warning | info | success */, snackBarTitle, snackBarMsg) {
        this.setState({ isSnackbarOpen: severity, snackBarTitle, snackBarMsg })
    }
    handleCloseSnackbar() {
        this.setState({ isSnackbarOpen: false })
    }

    onSubmit = async values => {
        const { ccy, authUser, fxrates = [] } = this.props;
        const selectedFXRate = fxrates.find(fx => fx.currency === ccy);
        const bag = authUser && authUser.bag || []
        const totalPrice = this.getTotalPrice();

        values.bagItems = bag.map(b => ({
            ...b,
            stock: b.stock._id,
            itemPrice: b.selectedUnit === 'items' ? undefined : this.getItemPrice(b),
            ppc: b.stock.StkCatType === 'Multiple Items' ? b.stock.ppc : undefined,
            type: b.stock.StkCatType === 'Multiple Items' ? 'parcel' : 'single',
        }))

        smoothScrollTop();

        this.openSnackbar(
            'warning',
            'Sending',
            'Don’t close your navigator or an error could occur'
        )

        api.post(`/profile/bagRequest`, { ...values, ccy, totalPrice, ExRate: selectedFXRate.ExRate })
            .then((res) => {
                this.props.setAuthUser(res.data);
            })
            .catch((err) => {
                console.log(err)
            })

        this.openSnackbar(
            'success',
            'Success',
            'Your Request has been sent successfully.',
        )

    }

    getItemPrice(b) {
        const { ccy, fxrates = [] } = this.props;
        const stock = b.stock;
        const isParcel = stock.StkCatType === 'Multiple Items';
        let itemPrice = 0;

        stock.WebSpecial = stock.WebSpecial && parseFloat(stock.WebSpecial) || 0;

        if (!isParcel) {
            itemPrice = convertToCurrency(stock.WebSpecial || stock.price || stock.ExWebTotal, false, fxrates, ccy);
        } else if (b.selectedUnit === 'weight') {
            itemPrice = Math.round(convertToCurrency(stock.WebSpecial || stock.ppc, true, fxrates, ccy)) * b.weight;
        }

        return itemPrice;
    }

    getTotalPrice() {
        const { authUser } = this.props;
        const bag = authUser && authUser.bag || []
        const total = bag.map(b => {
            const isParcel = b.stock.StkCatType === 'Multiple Items';
            return !isParcel ? Math.round(this.getItemPrice(b)) : this.getItemPrice(b);
        }).filter(p => p).reduce((a, c) => parseFloat(a) + parseFloat(c), 0)
        return parseFloat(total.toFixed(2))
    }

    areAllPriceableItems() {
        const { authUser } = this.props;
        const bag = authUser && authUser.bag || []
        const result = bag.filter(b => {
            const isParcel = b.stock.StkCatType === 'Multiple Items';
            return isParcel && b.selectedUnit === 'items' ? false : true;
        });
        return result.length === bag.length;
    }

    render() {
        const { sideDrawerOpen, isSnackbarOpen, snackBarTitle, snackBarMsg, orderNotes, acceptsAnyAlternatives } = this.state;
        const { classes, authUser, isAuthorised, ccy, fxrates=[], width } = this.props;
        const bag = authUser && authUser.bag || []
        const isMobile = ['xs', 'sm', 'md'].includes(width);

        function joinHenigArray(d, field) {
            return [d[field] && d[field][0] && d[field][0].From, d[field] && d[field][1] && d[field][1].To].filter(s => s).join(' to ')
        }

        return (<div className={style.wrapper}>

            <Form
                onSubmit={this.onSubmit}
                mutators={{
                    ...arrayMutators,
                    updateItemField: ([fieldName, value, index], state, utils) => {
                        this.props.updateItemInBag(bag[index].stock._id, fieldName, value)
                        utils.changeValue(state, `bagItems[${index}].${fieldName}`, (oldVal) => value)
                    },
                    updateAllItemsField: ([fieldName, value], state, utils) => {
                        this.props.updateItemInBag(bag.map(i => i.stock._id), fieldName, value)
                        bag.forEach((item, index) => {
                            utils.changeValue(state, `bagItems[${index}].${fieldName}`, (oldVal) => value)
                        })
                    },
                }}
                initialValues={{
                    bagItems: bag.map(b => ({
                        ...b,
                        stock: b.stock._id,
                    })),
                    orderNotes,
                    acceptsAnyAlternatives,
                }}
                render={({
                    handleSubmit,
                    form: {
                        mutators: {
                            push,
                            pop,
                            updateItemField,
                            updateAllItemsField,
                        }
                    }, // injected from final-form-arrays above
                    pristine,
                    form,
                    submitting,
                    values
                }) => {
                    return (
                        <form onSubmit={handleSubmit}>

                            {values.bagItems.length === 0 &&
                                <SecondaryNav
                                    value=""
                                    openDiamondSideDrawer={sideDrawerOpen}
                                    closeOrderBox={this.closeOrderBox}
                                />
                            }

                            <div className={style.inner}>
                                {/* https://codesandbox.io/s/kx8qv67nk5?file=/index.js:35-41 */}
                                {/* https://final-form.org/docs/react-final-form/examples */}
                                {/* https://github.com/lookfirst/mui-rff */}

                                {!isMobile && <BackButton to={'/diamonds/all'} className={style.backButton} />}

                                {!values.bagItems.length && <React.Fragment>
                                    <div className={style.emptyListMsg}>
                                        <h2>Your Bag</h2>
                                        <h3>Is Currently Empty</h3>
                                    </div>
                                    <div className={style.center}>
                                        <img alt="" src="/images/Screenshot 2020-11-18 at 10.32.36.jpg" />
                                    </div>
                                    <div className={style.center}>
                                        <br/>
                                        <Link to="/diamonds/all">
                                            <Button type="button" variant="contained" color="secondary" >Go shop</Button>
                                        </Link>
                                    </div>
                                </React.Fragment>}

                                {values.bagItems.length > 0 && <div className={style.bagTableWrap}>

                                    <div className={style.bagTableInner}>
                                        <h2>
                                            <Badge badgeContent={values.bagItems.length} color="primary" classes={{ badge: classes.badge }}>
                                                Your Bag
                                            </Badge>
                                        </h2>

                                        <Table className={style.table} aria-label="simple table" style={{ width: "auto", tableLayout: "auto" }}>
                                            {!isMobile && <TableHead>
                                                <TableRow>
                                                    <TableCell className={style.cellWrap}>Product</TableCell>
                                                    <TableCell align="center" className={style.cellWrap}>Price Per Carat</TableCell>
                                                    <TableCell style={{ width: '1%' }} align="center" className={style.cellWrap}>Weight/Items</TableCell>
                                                    <TableCell align="right" className={style.cellWrap}>Price</TableCell>
                                                    <TableCell align="center" className={style.cellWrap}>
                                                        <span className={style.alternativesHeadCell}><span>Alternatives</span><MouseOverPopover /></span>
                                                    </TableCell>
                                                    <TableCell align="right" className={style.cellWrap}></TableCell>
                                                </TableRow>
                                            </TableHead>}
                                            <TableBody>

                                                <FieldArray name="bagItems">
                                                    {({ fields }) => fields.map((name, index) => {
                                                        const selectedUnit = values.bagItems[index].selectedUnit || 'weight';
                                                        const weight = values.bagItems[index].weight;
                                                        const s = (bag[index] && bag[index].stock) || false;

                                                        if (!s) return;

                                                        const isParcel = s.StkCatType === 'Multiple Items';
                                                        const colour = joinHenigArray(s, 'Colour');
                                                        const clarity = joinHenigArray(s, 'Clarity');

                                                        s.WebSpecial = s.WebSpecial && parseFloat(s.WebSpecial) || 0;

                                                        const row = {
                                                            ...s,
                                                            name: isParcel ? `${s.StkShape} PARCEL` : `${numeral(s.STWeight).format('0.00')} CT ${s.StkShape} DIAMOND`,
                                                            img: `/images/${isOtherShape(isParcel, s.StkShape) ? 'round' : s.StkShape.toLowerCase()}${isParcel ? '_parcel.png' : '.png'}`,
                                                            subtitles: isParcel ? [[s.StkMes1, s.StkMes2, s.StkMes3].map(s => s && `${s}mm` || '-').join(' x ')] : [`${numeral(s.STWeight).format('0.00')}ct`, colour || '-', clarity || '-'],
                                                            price: s.WebSpecial || s.price || s.ExWebTotal,
                                                            specialOffer: s.WebSpecial > 0 ? true : false,
                                                            isParcel,
                                                        }; // to get the extra values from bag

                                                        return (
                                                            <TableRow key={row.name}>
                                                                <TableCell component="th" scope="row">
                                                                    <div className={style.productWrap}>
                                                                        <div className={classNames(style.thumb, row.isParcel && style.thumbParcel)}>
                                                                            <Link to={`/diamonds/${row._id}/details`}>
                                                                                <img alt="" src={row.img} />
                                                                            </Link>
                                                                        </div>
                                                                        <div className={style.infoWrap}>
                                                                            {!isMobile && <div className={style.title}>
                                                                                {row.name}
                                                                            </div>}
                                                                            {isMobile && <div className={classNames(style.title, style.titleMobile)}>
                                                                                <div className={style.name}>{row.name}</div>
                                                                                <div className={style.remove}>
                                                                                    <Button
                                                                                        type="button"
                                                                                        color="default"
                                                                                        onClick={() => {
                                                                                            fields.remove(index)
                                                                                            this.props.removeFromBag(row._id);
                                                                                        }}
                                                                                        variant="text"
                                                                                    >
                                                                                        REMOVE
                                                                                    </Button>
                                                                                </div>
                                                                            </div>}
                                                                            <div>
                                                                                <ul>
                                                                                    {[row.StkCodeCalcNS, ...row.subtitles, row.StkCertSup].filter(p => p).map(s => <li key={s}>{s}</li>)}
                                                                                </ul>

                                                                                {isMobile && <div className={style.mobilePrice}>
                                                                                    {!isParcel && <div className={classNames(style.cellWrap, style.cellPrice, row.specialOffer && style.specialOffer)}>
                                                                                        <div>{getSymbolFromCurrency(ccy)}{numeral(Math.round(this.getItemPrice({ stock: s, selectedUnit, weight }))).format('0,0.00').split('.')[0]}.<small>{numeral(Math.round(this.getItemPrice({ stock: s, selectedUnit, weight }))).format('0,0.00').split('.')[1]}</small></div>
                                                                                    </div>}
                                                                                    {isParcel && <div className={classNames(style.cellWrap, style.cellPrice, row.specialOffer && style.specialOffer)}>
                                                                                        {
                                                                                            selectedUnit === 'weight'
                                                                                                ? <div>{getSymbolFromCurrency(ccy)}{numeral(this.getItemPrice({ stock: s, selectedUnit, weight })).format('0,0.00').split('.')[0]}.<small>{numeral(this.getItemPrice({ stock: s, selectedUnit, weight })).format('0,0.00').split('.')[1]}</small></div>
                                                                                                : 'N/A'
                                                                                        }
                                                                                    </div>}
                                                                                </div>}

                                                                                {isMobile && <div className={style.mobileWeightItemsInput}>
                                                                                    {!row.isParcel && <span className={style.singleLabel}>Single</span>}
                                                                                    {row.isParcel &&
                                                                                        <NumberFieldStyled name={`${name}.${selectedUnit}`} selectedUnit={selectedUnit} onChange={(value, itemType) => updateItemField(itemType, value, index)} />
                                                                                    }
                                                                                </div>}
                                                                            </div>
                                                                        </div>
                                                                    </div>
                                                                </TableCell>
                                                                {!isMobile && <TableCell align="center">
                                                                    <div className={classNames(style.cellWrap, style.cellPrice)}>
                                                                        {!isParcel && <React.Fragment>
                                                                            {getSymbolFromCurrency(ccy)}{numeral(Math.round(this.getItemPrice({ stock: s, selectedUnit, weight })) / parseFloat(s.STWeight)).format('0,0.00').split('.')[0]}.<small>{numeral(Math.round(this.getItemPrice({ stock: s, selectedUnit, weight })) / parseFloat(s.STWeight)).format('0,0.00').split('.')[1]}</small>
                                                                        </React.Fragment>}

                                                                        {isParcel && <React.Fragment>
                                                                            {getSymbolFromCurrency(ccy)}{numeral(Math.round(convertToCurrency(s.WebSpecial || s.ppc, isParcel, fxrates, ccy))).format('0,0.00').split('.')[0]}.<small>{numeral(Math.round(convertToCurrency(s.ppc, isParcel, fxrates, ccy))).format('0,0.00').split('.')[1]}</small>
                                                                        </React.Fragment>}
                                                                    </div>
                                                                </TableCell>}
                                                                {!isMobile && <TableCell align="center">
                                                                    <div className={style.cellWrap}>
                                                                        {!row.isParcel && 'Single'}
                                                                        {row.isParcel &&
                                                                            <NumberFieldStyled name={`${name}.${selectedUnit}`} selectedUnit={selectedUnit} onChange={(value, itemType) => updateItemField(itemType, value, index)} />
                                                                        }
                                                                    </div>
                                                                </TableCell>}
                                                                {!isMobile && <TableCell align="right">
                                                                    {!isParcel && <div className={classNames(style.cellWrap, style.cellPrice, row.specialOffer && style.specialOffer)}>
                                                                        <div>{getSymbolFromCurrency(ccy)}{numeral(Math.round(this.getItemPrice({ stock: s, selectedUnit, weight }))).format('0,0.00').split('.')[0]}.<small>{numeral(Math.round(this.getItemPrice({ stock: s, selectedUnit, weight }))).format('0,0.00').split('.')[1]}</small></div>
                                                                    </div>}
                                                                    {isParcel && <div className={classNames(style.cellWrap, style.cellPrice, row.specialOffer && style.specialOffer)}>
                                                                        {
                                                                            selectedUnit === 'weight'
                                                                                ? <div>{getSymbolFromCurrency(ccy)}{numeral(this.getItemPrice({ stock: s, selectedUnit, weight })).format('0,0.00').split('.')[0]}.<small>{numeral(this.getItemPrice({ stock: s, selectedUnit, weight })).format('0,0.00').split('.')[1]}</small></div>
                                                                                : 'N/A'
                                                                        }
                                                                    </div>}
                                                                </TableCell>}
                                                                {!isMobile && <TableCell align="center">
                                                                    <div className={classNames(style.cellWrap, style.cellAlternatives)}>
                                                                        <Checkboxes
                                                                            name={`${name}.acceptsAlternatives`}
                                                                            data={[{ value: 'y' }]}
                                                                            icon={<CheckCircleIcon style={{ opacity: 0.2 }} />} checkedIcon={<CheckCircleIcon style={{ color: '#b08f6e' }} />}
                                                                            onChange={(e, value) => {
                                                                                updateItemField('acceptsAlternatives', value, index)
                                                                                if (!value) {
                                                                                    this.setState({ acceptsAnyAlternatives: false })
                                                                                }
                                                                            }}
                                                                        />
                                                                    </div>
                                                                </TableCell>}
                                                                {!isMobile && <TableCell align="right">
                                                                    <div className={style.cellWrap}>
                                                                        <Button
                                                                            type="button"
                                                                            color="default"
                                                                            onClick={() => {
                                                                                fields.remove(index)
                                                                                this.props.removeFromBag(row._id);
                                                                            }}
                                                                            variant="text"
                                                                        >
                                                                            Remove
                                                                        </Button>
                                                                    </div>
                                                                </TableCell>}
                                                            </TableRow>
                                                        )
                                                    })}
                                                </FieldArray>

                                            </TableBody>
                                        </Table>

                                        <div className={style.priceTotals}>
                                            <div>
                                                <div className={style.labels}>Total </div>
                                                <div className={style.amounts}>
                                                    {this.areAllPriceableItems() ? <React.Fragment>{getSymbolFromCurrency(ccy)}{numeral(this.getTotalPrice()).format('0,0.00').split('.')[0]}.<small>{numeral(this.getTotalPrice()).format('0,0.00').split('.')[1]}</small></React.Fragment> : 'N/A'}
                                                </div>
                                            </div>
                                        </div>
                                    </div>

                                    <div>
                                        <div className={style.requestBox}>

                                            <label>Order Notes</label>

                                            <TextField
                                                placeholder="Start typing your message..."
                                                fullWidth
                                                multiline
                                                rows={20}
                                                name={`orderNotes`}
                                                onChange={(e) => this.setState({ orderNotes: e.target.value })}
                                            />

                                            <div>
                                                <Checkboxes
                                                    name="acceptsAnyAlternatives"
                                                    data={[{ label: 'Alternatives to all items', value: 'y' }]}
                                                    icon={<CheckCircleIcon style={{ opacity: 0.2 }} />} checkedIcon={<CheckCircleIcon style={{ color: '#b08f6e' }} />}
                                                    onChange={(e, value) => {
                                                        updateAllItemsField('acceptsAlternatives', value)
                                                        this.setState({ acceptsAnyAlternatives: value })
                                                    }}
                                                />
                                            </div>


                                            <div style={{ position: 'absolute', bottom: 0, left: 0 }}>
                                                <BoxButton
                                                    disabled={submitting}
                                                    text={'SEND REQUEST'}
                                                    iconPath="/images/Screenshot 2020-11-07 at 10.43.49.jpg"
                                                />
                                            </div>

                                        </div>
                                    </div>

                                </div>}
                            </div>

                            <br />
                        </form>
                    )
                }}
            />

            <NoticeBar
                open={isSnackbarOpen}
                onClose={() => this.handleCloseSnackbar()}
                title={snackBarTitle}
                message={snackBarMsg}
            />

        </div>);
    }
}

Bag.propTypes = {
    selectBag: PropTypes.func.isRequired,
    classes: PropTypes.object.isRequired,
    width: PropTypes.string.isRequired,
};

export default connect(
    (state) => ({
        authUser: state.auth.user,
        isAuthorised: state.auth.isAuthorised,
        ccy: state.site.ccy,
        fxrates: state.site.fxrates,
    }),
    (dispatch) => bindActionCreators({ ...AuthActions }, dispatch)
)(withWidth()(withStyles(styles, { withTheme: true })(Bag)));
